import React from "react";
import { ClipboardCheck } from "lucide-react";

const InspectionsHeader = ({ stats }) => {
  return (
    <div className="flex items-center justify-between">
      <div>
        <h2 className="text-2xl font-bold text-gray-800">Inspections</h2>
        <p className="text-gray-600">QA/QC inspection workflow: Draft → Submit → Approve/Reject. Approved is final for reports.</p>
        <p className="text-sm text-gray-500 mt-1">
          Total: {stats?.total ?? 0} • Draft: {stats?.draft ?? 0} • Submitted: {stats?.submitted ?? 0} • Approved:{" "}
          {stats?.approved ?? 0}
        </p>
      </div>
      <ClipboardCheck className="w-8 h-8 text-orange-500" />
    </div>
  );
};

export default React.memo(InspectionsHeader);
